import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import BryxColors from "../types/theme";
import BryxTypography from "./BryxTypography";
const BryxLayoutButton = styled((props) => {
    const { columnNum, selected, ...other } = props;
    let shownText = "Invalid Column Number";
    let colSvg;
    switch (columnNum) {
        case 1: {
            shownText = "1 Column";
            colSvg = (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "97", height: "32", viewBox: "0 0 97 32", children: _jsx("rect", { width: "97", height: "32", rx: "2" }) }));
            break;
        }
        case 2: {
            shownText = "2 Columns";
            colSvg = new Array(2).fill(_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "46", height: "32", viewBox: "0 0 46 32", children: _jsx("rect", { width: "46", height: "32", rx: "2" }) }));
            break;
        }
        case 3: {
            shownText = "3 Columns";
            colSvg = new Array(3).fill(_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "29", height: "32", viewBox: "0 0 29 32", children: _jsx("rect", { width: "29", height: "32", rx: "2" }) }));
            break;
        }
        case 4: {
            shownText = "4 Columns";
            colSvg = new Array(4).fill(_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "21", height: "32", viewBox: "0 0 21 32", children: _jsx("rect", { width: "21", height: "32", rx: "2" }) }));
            break;
        }
        case 5: {
            shownText = "5 Columns";
            colSvg = new Array(5).fill(_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "32", viewBox: "0 0 17 32", children: _jsx("rect", { width: "17", height: "32", rx: "2" }) }));
            break;
        }
    }
    return (_jsxs(Box, { alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column", ...other, sx: { width: "129px", height: "98px" }, children: [_jsx(Button, { variant: "contained", disableElevation: true, children: colSvg }), shownText && _jsx(BryxTypography, { variant: "body1", children: shownText })] }));
})(({ theme, selected, columnNum }) => {
    const pallete = theme.palette.mode;
    return {
        "& .MuiButton-root": {
            width: "129px",
            height: "64px",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            gap: columnNum == 2 ? "5px" : "4px",
            backgroundColor: selected ? BryxColors.brand3(pallete) : BryxColors.layoutButtonBackground(pallete),
            color: selected ? BryxColors.brandPrimary(pallete) : BryxColors.notify(pallete, "inactive"),
        },
        "& .MuiTypography-root": {
            transition: "250ms",
            marginTop: "16px",
            color: selected ? BryxColors.brandPrimary(pallete) : BryxColors.notify(pallete, "inactive"),
        },
        "& svg": {
            fill: selected ? BryxColors.brandPrimary(pallete) : BryxColors.notify(pallete, "inactive"),
        },
        "&:hover": {
            "& .MuiButton-root": {
                backgroundColor: BryxColors.layoutButtonBackground(pallete),
                color: BryxColors.brand1(pallete),
            },
            "& .MuiTypography-root": {
                color: BryxColors.brand1(pallete),
            },
            "& svg": {
                fill: BryxColors.brand1(pallete),
            },
        },
    };
});
export default BryxLayoutButton;
